'use strict';

angular.module('ecrd.core')
    .provider('CoreRecord', function() {
        this.$get = ['$window', 'CoreEcrd', function CoreRecord($window, CoreEcrd) {
            return new $window.ShareCrfCore.RecordBase(CoreEcrd);
        }];
    });
